// extracted by mini-css-extract-plugin
export default {"Navegation":"Nav_Navegation__DgcLo","AboutButton":"Nav_AboutButton__pi9dJ","ProyectosButton":"Nav_ProyectosButton__RQgSd","HomeButton":"Nav_HomeButton__nTeAT"};